module.exports = {"TXTCLI_Tournament_Information":{"id":"TXTCLI_Tournament_Information","defaultMessage":"Informação de Torneio"}}